<template>
  <div class="beneficiary-information-form-container">
    <Panel title="4. รายละเอียดผู้รับผลประโยชน์">
      <div class="legal-heir-container" v-if="isLegalheir">
        เป็นทายาทตามกฏหมาย
      </div>
      <div class="beneficiary-information-section" v-else>
        <div class="beneficiary-form-section" v-if="!beneficiaryFirstPerson.isNull">
          <div class="beneficiary-information">
            <div class="information-label">ผู้รับผลประโยชน์คนที่ 1</div>
            <div class="information-description">
              {{
                `${beneficiaryFirstPerson.namePrefix || ''} ${beneficiaryFirstPerson.firstname} ${
                  beneficiaryFirstPerson.lastname
                }`
              }}
            </div>
          </div>
          <div class="beneficiary-form">
            <div class="form-group">
              <div class="input-group">
                <span class="input-group-addon nobd-nobg">มีความสัมพันธ์เป็น</span>
                <Dropdown
                  class="form-control input-sm"
                  :options="generateBeneficiaryRelationshipOptions('beneficiaryFirstPerson')"
                  :class="{
                    'bd-red': applicationValidationErrors.has('beneficiaryFirstPersonRelationship'),
                  }"
                  v-model="beneficiaryFirstPerson.relationship"
                  :selectedValue="beneficiaryFirstPerson.relationship"
                  :disabled="isDisabledForm || beneficiaryFirstPerson.isNull"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="input-group">
                <span class="input-group-addon nobd-nobg">สัดส่วนร้อยละ</span>
                <Dropdown
                  class="form-control input-sm"
                  :class="{
                    'bd-red': applicationValidationErrors.has('beneficiaryFirstPersonPercentage'),
                  }"
                  v-model="beneficiaryFirstPerson.percentage"
                  :selectedValue="beneficiaryFirstPerson.percentage"
                  :options="generateBenefitOptions"
                  :disabled="isDisabledForm || isBeneficiaryNull"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="beneficiary-form-section" v-if="!beneficiarySecondPerson.isNull">
          <div class="beneficiary-information">
            <div class="information-label">ผู้รับผลประโยชน์คนที่ 2</div>
            <div class="information-description">
              {{
                `${beneficiarySecondPerson.namePrefix || ''} ${beneficiarySecondPerson.firstname} ${
                  beneficiarySecondPerson.lastname
                }`
              }}
            </div>
          </div>
          <div class="beneficiary-form">
            <div class="form-group">
              <div class="input-group">
                <span class="input-group-addon nobd-nobg">มีความสัมพันธ์เป็น</span>
                <Dropdown
                  class="form-control input-sm"
                  :options="generateBeneficiaryRelationshipOptions('beneficiarySecondPerson')"
                  :class="{
                    'bd-red': applicationValidationErrors.has(
                      'beneficiarySecondPersonRelationship',
                    ),
                  }"
                  v-model="beneficiarySecondPerson.relationship"
                  :selectedValue="beneficiarySecondPerson.relationship"
                  :disabled="isDisabledForm"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="input-group">
                <span class="input-group-addon nobd-nobg">สัดส่วนร้อยละ</span>
                <Dropdown
                  class="form-control input-sm"
                  :class="{
                    'bd-red': applicationValidationErrors.has('beneficiarySecondPersonPercentage'),
                  }"
                  v-model="beneficiarySecondPerson.percentage"
                  :selectedValue="beneficiarySecondPerson.percentage"
                  :options="generateBenefitOptions"
                  :disabled="isDisabledForm || isBeneficiaryNull"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import _ from 'lodash'

import Dropdown from '@/components/Dropdown'
import Panel from '@/components/Panel'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

const { mapFields: mapFamilyFields } = createHelpers({
  getterType: 'getFamilyFields',
  mutationType: 'updateFamilyFields',
})

export default {
  name: 'BeneficiaryInformationForm',
  watch: {
    'beneficiaryFirstPerson.percentage'(val, old) {
      if (val !== old && this.beneficiarySecondPerson) {
        this.beneficiarySecondPerson.percentage = 100 - val
      }
    },
    'beneficiarySecondPerson.percentage'(val, old) {
      if (val !== old && this.beneficiaryFirstPerson) {
        this.beneficiaryFirstPerson.percentage = 100 - val
      }
    },
  },
  computed: {
    ...mapGetters({
      isDisabledForm: 'isDisabledApplicationForm',
      applicationValidationRules: 'applicationValidationRules',
    }),
    ...mapApplicationFields({
      isLegalheir: 'data.beneficiary.isBeneficiaryLegalHeir',
      beneficiaryFirstPerson: 'data.beneficiary.firstPerson',
      beneficiarySecondPerson: 'data.beneficiary.secondPerson',
      applicationValidationErrors: 'validation.errors',
    }),
    ...mapFamilyFields({
      beneficiaryRelationship: 'beneficiaryRelationship.data',
    }),
    generateBenefitOptions() {
      const options = []

      if (this.beneficiaryFirstPerson && this.beneficiarySecondPerson) {
        for (let i = 0; i <= 10; i += 1) {
          const optionsValue = i * 10

          options.push({
            value: optionsValue,
            description: optionsValue,
          })
        }

        return options
      }

      return [{ value: 100, description: 100 }]
    },
    generateBeneficiaryRelationshipOptions() {
      return person => {
        const defaultOption = {
          value: '',
          description: 'โปรดระบุความสัมพันธ์',
        }

        const beneficiaryRelationshipOptions = this.beneficiaryRelationship.map(data => ({
          value: data.id,
          description: data.description,
        }))

        if (this[person].relationship) {
          return beneficiaryRelationshipOptions
        }

        return [defaultOption, ...beneficiaryRelationshipOptions]
      }
    },
    isBeneficiaryNull() {
      return this.beneficiaryFirstPerson.isNull || this.beneficiarySecondPerson.isNull
    },
  },
  components: {
    Dropdown,
    Panel,
  },
}
</script>

<style lang="scss">
.beneficiary-information-form-container {
  .beneficiary-information-section {
    .beneficiary-form-section {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(325px, 1fr));

      .beneficiary-information {
        align-items: center;
        display: flex;
        margin-bottom: 15px;

        .information-label {
          margin-right: 8px;
        }

        .information-description {
          color: #00a350;
        }
      }

      .beneficiary-form {
        display: grid;
        grid-template-columns: 1fr 155px;
      }
    }
  }
}
</style>
